var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ml-0 mr-0 pl-0 pr-0"},[_c('v-btn',{class:_vm.rounded ? 'rounded-pill' : 'rounded-lg',attrs:{"color":_vm.color,"elevation":"0","outlined":_vm.outlined,"type":_vm.type,"name":_vm.name,"form":_vm.form,"width":_vm.width},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }